
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { CheckCircle, Users, Zap, Shield } from "lucide-react";

const FeaturesSection = () => {
  const features = [
    "AI-powered VC research & scoring",
    "Bulk data processing (100+ VCs)",
    "Personalized email generation",
    "Advanced analytics dashboard",
    "Contact matching & enrichment",
    "Export capabilities",
    "Priority support"
  ];

  return (
    <section className="container mx-auto px-6 py-20">
      <div className="text-center mb-16">
        <h2 className="text-4xl font-bold text-gray-900 mb-4">Everything You Need to Close Your Round</h2>
        <p className="text-xl text-gray-600">Full platform access, completely free for accelerator members</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        <Card className="text-center">
          <CardHeader>
            <Users className="h-12 w-12 text-blue-600 mx-auto mb-4" />
            <CardTitle>Smart VC Matching</CardTitle>
            <CardDescription>AI-powered relevance scoring (0-10) with detailed analysis</CardDescription>
          </CardHeader>
          <CardContent>
            <ul className="space-y-2 text-sm text-left">
              {features.slice(0, 3).map((feature, index) => (
                <li key={index} className="flex items-center gap-2">
                  <CheckCircle className="h-4 w-4 text-green-500 flex-shrink-0" />
                  <span>{feature}</span>
                </li>
              ))}
            </ul>
          </CardContent>
        </Card>

        <Card className="text-center">
          <CardHeader>
            <Zap className="h-12 w-12 text-purple-600 mx-auto mb-4" />
            <CardTitle>Automation Tools</CardTitle>
            <CardDescription>Save 100+ hours with intelligent automation</CardDescription>
          </CardHeader>
          <CardContent>
            <ul className="space-y-2 text-sm text-left">
              {features.slice(3, 6).map((feature, index) => (
                <li key={index} className="flex items-center gap-2">
                  <CheckCircle className="h-4 w-4 text-green-500 flex-shrink-0" />
                  <span>{feature}</span>
                </li>
              ))}
            </ul>
          </CardContent>
        </Card>

        <Card className="text-center">
          <CardHeader>
            <Shield className="h-12 w-12 text-green-600 mx-auto mb-4" />
            <CardTitle>Premium Support</CardTitle>
            <CardDescription>Dedicated support for accelerator members</CardDescription>
          </CardHeader>
          <CardContent>
            <ul className="space-y-2 text-sm text-left">
              <li className="flex items-center gap-2">
                <CheckCircle className="h-4 w-4 text-green-500 flex-shrink-0" />
                <span>Priority customer support</span>
              </li>
              <li className="flex items-center gap-2">
                <CheckCircle className="h-4 w-4 text-green-500 flex-shrink-0" />
                <span>Onboarding assistance</span>
              </li>
              <li className="flex items-center gap-2">
                <CheckCircle className="h-4 w-4 text-green-500 flex-shrink-0" />
                <span>Fundraising strategy guidance</span>
              </li>
            </ul>
          </CardContent>
        </Card>
      </div>
    </section>
  );
};

export default FeaturesSection;
